module.exports = __webpack_public_path__ + "img/wap.6e87ef31.png";